import { render, staticRenderFns } from "./order-slideout.vue?vue&type=template&id=6158c3b6&scoped=true&"
import script from "./order-slideout.vue?vue&type=script&lang=js&"
export * from "./order-slideout.vue?vue&type=script&lang=js&"
import style0 from "./order-slideout.vue?vue&type=style&index=0&id=6158c3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6158c3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6158c3b6')) {
      api.createRecord('6158c3b6', component.options)
    } else {
      api.reload('6158c3b6', component.options)
    }
    module.hot.accept("./order-slideout.vue?vue&type=template&id=6158c3b6&scoped=true&", function () {
      api.rerender('6158c3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/order-slideout.vue"
export default component.exports